var _rect, _mask, _path, _path2, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundTicks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 547,
    height: 137,
    viewBox: "0 0 547 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.9216,
    y: 85.6403,
    width: 36.5625,
    height: 36.5625,
    rx: 8.53125,
    transform: "rotate(30 18.9216 85.6403)",
    fill: "#EE46BC",
    stroke: "url(#paint0_linear_16_247)",
    strokeWidth: 0.9375
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_16_247",
    maskUnits: "userSpaceOnUse",
    x: 13.8848,
    y: 99.7697,
    width: 23.5885,
    height: 22.8564,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 13.8848,
    y: 99.7697,
    width: 23.5885,
    height: 22.8564
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.128 115.499L20.126 115.498C19.9049 115.371 19.7539 115.148 19.7161 114.897L18.6315 107.775C18.5614 107.314 18.877 106.884 19.3384 106.814C19.8007 106.745 20.2298 107.061 20.2994 107.521L21.2265 113.606L34.435 108.532C34.8704 108.365 35.358 108.581 35.5253 109.018C35.6922 109.453 35.4754 109.941 35.04 110.108L20.8524 115.557C20.6141 115.648 20.3482 115.627 20.128 115.499Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.128 115.499L20.126 115.498C19.9049 115.371 19.7539 115.148 19.7161 114.897L18.6315 107.775C18.5614 107.314 18.877 106.884 19.3384 106.814C19.8007 106.745 20.2298 107.061 20.2994 107.521L21.2265 113.606L34.435 108.532C34.8704 108.365 35.358 108.581 35.5253 109.018C35.6922 109.453 35.4754 109.941 35.04 110.108L20.8524 115.557C20.6141 115.648 20.3482 115.627 20.128 115.499Z",
    fill: "#FCCEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.128 115.499L20.126 115.498C19.9049 115.371 19.7539 115.148 19.7161 114.897L18.6315 107.775C18.5614 107.314 18.877 106.884 19.3384 106.814C19.8007 106.745 20.2298 107.061 20.2994 107.521L21.2265 113.606L34.435 108.532C34.8704 108.365 35.358 108.581 35.5253 109.018C35.6922 109.453 35.4754 109.941 35.04 110.108L20.8524 115.557C20.6141 115.648 20.3482 115.627 20.128 115.499Z",
    stroke: "#FCCEEE",
    mask: "url(#path-2-outside-1_16_247)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 508.48,
    y: 14.1912,
    width: 27.4219,
    height: 27.4219,
    rx: 6.39844,
    transform: "rotate(-30 508.48 14.1912)",
    fill: "#EE46BC",
    stroke: "url(#paint1_linear_16_247)",
    strokeWidth: 0.703125
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_247)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-2_16_247",
    maskUnits: "userSpaceOnUse",
    x: 518.427,
    y: 10.4736,
    width: 18.1244,
    height: 17.3923,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 518.427,
    y: 10.4736,
    width: 18.1244,
    height: 17.3923
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.327 24.6048L528.325 24.6057C528.159 24.7014 527.958 24.7162 527.781 24.6463L522.748 22.6803C522.422 22.5528 522.262 22.1867 522.389 21.8607C522.517 21.5344 522.884 21.3744 523.209 21.5016L527.509 23.1812L529.166 12.6995C529.221 12.3541 529.544 12.1181 529.891 12.1733C530.236 12.2282 530.472 12.552 530.417 12.8974L528.635 24.1557C528.605 24.3447 528.492 24.5095 528.327 24.6048Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M528.327 24.6048L528.325 24.6057C528.159 24.7014 527.958 24.7162 527.781 24.6463L522.748 22.6803C522.422 22.5528 522.262 22.1867 522.389 21.8607C522.517 21.5344 522.884 21.3744 523.209 21.5016L527.509 23.1812L529.166 12.6995C529.221 12.3541 529.544 12.1181 529.891 12.1733C530.236 12.2282 530.472 12.552 530.417 12.8974L528.635 24.1557C528.605 24.3447 528.492 24.5095 528.327 24.6048Z",
    fill: "#FCCEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.327 24.6048L528.325 24.6057C528.159 24.7014 527.958 24.7162 527.781 24.6463L522.748 22.6803C522.422 22.5528 522.262 22.1867 522.389 21.8607C522.517 21.5344 522.884 21.3744 523.209 21.5016L527.509 23.1812L529.166 12.6995C529.221 12.3541 529.544 12.1181 529.891 12.1733C530.236 12.2282 530.472 12.552 530.417 12.8974L528.635 24.1557C528.605 24.3447 528.492 24.5095 528.327 24.6048Z",
    stroke: "#FCCEEE",
    strokeWidth: 0.75,
    mask: "url(#path-4-outside-2_16_247)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_247",
    x1: 37.5,
    y1: 85,
    x2: 37.5,
    y2: 122.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD2590",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_247",
    x1: 522.063,
    y1: 14.0625,
    x2: 522.063,
    y2: 42.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD2590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD2590",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.1875,
    height: 15.1875,
    fill: "white",
    transform: "translate(517.066 16.4919) rotate(-30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundTicks);
export default __webpack_public_path__ + "static/media/background-ticks.b528f705af187a01f611daec610e5b50.svg";
export { ForwardRef as ReactComponent };